import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ReactComponent as Location } from "../../../../assets/svg/location-inside-circle.svg";
import { ReactComponent as Service } from "../../../../assets/svg/service.svg";
import { IconWithText } from "../../../program/components/IconWithText";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
  },
  itemContainer: {
    width: "50%",
  },
  container: {
    fontSize: 16,
    color: "#858997",
    fontWeight: 500,
    marginTop: 7,
    paddingLeft: 50,
  },
  countryContainer: {
    maxWidth: 500,
    wordBreak: "break-all",
  },
  link: {
    fontSize: 16,
    color: "#7D9EF1",
    fontWeight: 500,
    "&:hover": {
      textDecoration: "none",
      color: "#5E88F1",
    },
  },
  iconTextContainerForLink: {
    display: "flex",
    columnGap: 10,
  },
}));

interface ViewMoreSubInfoProps {
  country: string;
  serviceType: string;
}

export const ViewMoreSubInfoWidget: FC<ViewMoreSubInfoProps> = ({
  country,
  serviceType,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.itemContainer}>
        <IconWithText Icon={Location} title="Country" />
        <div className={classes.container}>{country}</div>
      </div>
      <div>
        <IconWithText Icon={Service} title="Service Type" />
        <div className={classes.container}>{serviceType}</div>
      </div>
    </div>
  );
};
